import React from 'react';
import { themed } from '../../ui/theme';

interface Props {
  children: React.ReactNode;
  className?: string;
  /** Usar quando o card tem cabeçalho/itens com bordas que precisam ser recortados. */
  clip?: boolean;
}

// Container padrão de painel/seção. Cor e raio vêm dos tokens (styles/tokens.css):
// o fundo troca sozinho no modo escuro e o raio acompanha o tema de deploy.
//   minimal: sem sombra.
//   saas:    sombra suave.
const Card: React.FC<Props> = ({ children, className = '', clip = false }) => (
  <section className={`rounded-panel border border-line bg-surface ${clip ? 'overflow-hidden' : ''} ${themed({
    minimal: '',
    saas: 'shadow-sm',
  })} ${className}`}>
    {children}
  </section>
);

export default Card;
